import { render } from "./Column202402.vue?vue&type=template&id=79b8aed0&scoped=true"
import script from "./Column202402.vue?vue&type=script&lang=js"
export * from "./Column202402.vue?vue&type=script&lang=js"

import "./Column202402.vue?vue&type=style&index=0&id=79b8aed0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79b8aed0"]])

export default __exports__